import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import { can as evaluateCan } from '@/utils/managerPermissions';

/**
 * Permissões efetivas da sessão (GET /manager/me) para UX: menu, rotas, disabled.
 * O backend continua sendo a fonte de verdade (403 se faltar permissão).
 */
export function useManagerCan() {
  const userStore = useUserStore();
  const { meData } = storeToRefs(userStore);

  const permissions = computed(() => meData.value?.permissions);

  const can = (resource: string, action: string): boolean =>
    evaluateCan(permissions.value, resource, action);

  return { permissions, can };
}
